<template>
  <DropdownMenuSeparator v-bind="delegatedProps" :class="cn('tw--mx-1 tw-my-1 tw-h-px tw-bg-muted', props.class)" />
</template>

<script setup lang="ts">
import { cn } from "@/components/ui/utils"
import { DropdownMenuSeparator, type DropdownMenuSeparatorProps } from "radix-vue"
import { computed, type HTMLAttributes } from "vue"

const props = defineProps<
  DropdownMenuSeparatorProps & {
    class?: HTMLAttributes["class"]
  }
>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})
</script>
